import styled from '@emotion/styled';

import COLORS, { COLORS_TEXT, COLORS_BACKGROUND } from '@zola/zola-ui/src/styles/emotion/colors';
import ZINDEX from '@zola/zola-ui/src/styles/emotion/zIndex';
import FONTS from '@zola/zola-ui/src/styles/emotion/fonts';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';
import MEDIA_QUERY from '@zola/zola-ui/src/styles/emotion/mediaQuery';

const {
  FONT_FAMILY_POYNTER,
  FONT_SIZE_LARGER,
  FONT_SIZE_SMALL,
  FONT_SIZE_LARGE,
  FONT_SIZE_SEMI_LARGE,
  textSizeRegular,
} = FONTS;

export const Container = styled.div`
  background: ${COLORS_BACKGROUND.JEWEL_4};
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: ${ZINDEX.super};
  display: flex;
  justify-content: center;
  padding: 30px;
`;

export const ContentContainer = styled.div`
  max-width: 800px;
  width: 100%;
  overflow: auto;
  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  ${MEDIA_QUERY.DESKTOP} {
    padding-top: ${SPACING.LG};
  }
`;

export const Title = styled.div`
  color: ${COLORS.BLACK};
  font-family: ${FONT_FAMILY_POYNTER};
  ${textSizeRegular(FONT_SIZE_LARGER)};
  margin: ${SPACING.MD} 0;
`;

export const Content = styled.div`
  margin-bottom: 30px;
  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    margin-bottom: ${SPACING.MD};
  }
`;

export const PTag = styled.p`
  font-size: ${FONT_SIZE_SMALL}!important;
  line-height: ${FONT_SIZE_LARGE}!important;
  color: ${COLORS_TEXT.BODY}!important;
`;

export const Close = styled.button`
  right: 15px !important;
  height: 40px !important;
  span {
    font-size: ${FONT_SIZE_SEMI_LARGE};
    color: ${COLORS_TEXT.BODY};
  }
`;
